import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from "./router";
import VueMeta from 'vue-meta';
import moment from "moment-jalaali";
import VuePageTransition from 'vue-page-transition'
import goTo from 'vuetify/lib/services/goto'
import './registerServiceWorker';
import "@/assets/styles/master.css";
import "@/assets/styles/bootstrap.min.css";
import "@/assets/styles/fontawesome.min.css";
import "@/assets/styles/brands.css";
import "@/assets/styles/light.min.css";
import "@/assets/styles/solid.min.css";
import "@/assets/styles/vuetify.css";
import VueAddtohomescreen from "@owliehq/vue-addtohomescreen";
import VueGeolocation from 'vue-browser-geolocation';
import VueGtag from "vue-gtag";



import * as  VueGoogleMaps from 'vue2-google-maps'

Vue.prototype.$moment = function (date) {
    return moment(date).format('jYYYY/jM/jD');
};
Vue.use(VueGeolocation)
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCDfnJg1u4elSPk5-bFPHlKvF62D3YdgtU',
        libraries: '',
        language: 'fa'
    }
});


Vue.use(VueGtag, {
    config: { id: "G-92QRKXT0VF" }
}, router);

Vue.prototype.$global = {};
Vue.prototype.$global.comparelist = [];


Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl !== null) {
        return httpUrl.replace('http://', 'https://');
    }
};

Vue.use(VueAddtohomescreen);
Vue.use(VuePageTransition)
Vue.config.productionTip = false
Vue.prototype.$numberWithCommas = function (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

Vue.use(VueMeta);
Vue.prototype.$baseUrl = "https://api.aslanianmachine.com/";
Vue.prototype.$replaceHttps = function (httpUrl) {
    if (httpUrl !== null) {
        return httpUrl.replace('http://', 'https://');
        // return require("./assets/img/" + httpUrl);
    }
};

Vue.prototype.$openLink = function (url) {
    var newWindow = window.open("about:blank", "_blank");
    newWindow.location = url;
}

Vue.prototype.$scrollTop = function (x) {
    return goTo(x);
}

Vue.prototype.$convertDate = function (date) {
    let sliceDate = date.slice(0, 10)
    return moment(sliceDate).format('jYYYY/jMM/jDD')
}

Vue.prototype.$addToCompare = function (id) {
    console.log(id)
    console.log("$addToCompare");
    console.log(this.$global.comparelist);

    if (this.$global.comparelist.length === 4) {
        return "Array is full";
    }

    if (!this.$productExistsInCompare(id)) {
        this.$global.comparelist.push(id);
    }

    console.log(this.$global.comparelist);

}

Vue.prototype.$removeFromCompare = function (id) {
    console.log("$removeFromCompare");
    console.log(this.$global.comparelist);

    if (this.$global.comparelist.length === 0) {
        return "Array is empty";
    }
    this.$global.comparelist = this.$global.comparelist.filter(item => item !== id);

    console.log(this.$global.comparelist);
    return "Id removed";
}

Vue.prototype.$productExistsInCompare = function (id) {
    return this.$global.comparelist.filter(item => item === id).length === 1;

}

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#app')